import { BindAll } from 'lodash-decorators'
import { action, computed, observable } from 'mobx'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiShow } from '@xt/client/api'

function splitIntoGroups<T>(list: T[], count: number): T[][] {
  const result: T[][] = Array.from({ length: count }, () => [])
  list.forEach((item, index) => {
    result[index % count].push(item)
  })
  return result
}

@BindAll()
export class RandomWorks {
  @observable randomWorks: Array<{
    waterUrl: string
    originalWidth: number
    originalHeight: number
    id: number
    showId: number
  }> = []

  @observable isLoading = false

  @computed get randomWorksH5() {
    return splitIntoGroups(this.randomWorks, 2)
  }

  @computed get randomWorksPC() {
    return splitIntoGroups(this.randomWorks, 3)
  }

  // 获取随机作品
  async loadRandomWorks() {
    if (this.isLoading) return

    this.updateLoadingStatus(true)

    const [err, data] = await $service<
      Array<{
        pictureResultVOS: Array<{
          waterUrl: string
          originalWidth: number
          originalHeight: number
        }>
        showId: number
        id: number
      }>
    >({
      url: EnumApiShow.randomWorks
    })

    this.updateLoadingStatus(false)

    if (err) return

    const list = data.filter(item => Array.isArray(item.pictureResultVOS) && item.pictureResultVOS.length > 0)

    this.updateRandomWorks(
      list.map(item => ({
        waterUrl: item.pictureResultVOS[0].waterUrl,
        originalHeight: item.pictureResultVOS[0].originalHeight,
        originalWidth: item.pictureResultVOS[0].originalWidth,
        showId: item.showId,
        id: item.id
      }))
    )
  }

  @action
  updateLoadingStatus(isLoading: boolean) {
    this.isLoading = isLoading
  }

  @action
  updateRandomWorks(
    works: Array<{
      waterUrl: string
      originalWidth: number
      originalHeight: number
      id: number
      showId: number
    }>
  ) {
    this.randomWorks = works
  }
}
